const sectionStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "60px 20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "25px",
  background: "#fff",
  boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 15px 35px rgba(0,0,0,0.1)"
    : "0 10px 25px rgba(0,0,0,0.05)";
  e.currentTarget.style.transform = enter
    ? "translateY(-3px)"
    : "translateY(0)";
};

const AwsCourseSkillshare = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          Real-World AWS Development Course Now Available on Skillshare
        </h1>

        <p style={{ fontSize: "18px", color: "#555", maxWidth: "700px" }}>
          A hands-on course focused on building real, production-ready AWS systems
          using serverless architecture and multiple integrated services.
        </p>
      </div>


      {/* IMAGE */}
      <div style={{ ...sectionStyle, paddingTop: "0", textAlign: "center" }}>
        <img
          src="/images/realWorldAwsDevelopment.png"
          alt="Real-World AWS Development Course"
          style={{
            width: "100%",
            maxWidth: "750px",
            borderRadius: "14px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.15)"
          }}
        />

        <div style={{
          fontSize: "14px",
          color: "#777",
          marginTop: "10px"
        }}>
          Hands-on AWS serverless development course
        </div>
      </div>


      {/* INTRO CONTENT */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          I’m excited to share that my course <strong>“Real-World AWS Development”</strong>
          is now available on Skillshare.
        </p>

        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          This course is designed for developers who want to go beyond basic examples
          and build real, production-ready AWS solutions. Instead of focusing on isolated services,
          it walks through a complete project that integrates multiple AWS components.
        </p>
      </div>


      {/* WHAT YOU WILL LEARN (CARD SECTION 🔥) */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>What You’ll Learn</h2>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px"
        }}>
          {[
            "Design end-to-end serverless architectures for real-world applications",
            "Build production-ready APIs using API Gateway and AWS Lambda",
            "Model and optimize data access patterns with DynamoDB",
            "Implement event-driven workflows using Step Functions and event triggers",
            "Design scalable file processing pipelines with S3 and asynchronous processing",
            "Apply infrastructure as code using AWS SAM and CloudFormation",
            "Integrate multiple AWS services into a cohesive, maintainable system",
            "Debug, test, and validate cloud applications in real development scenarios",
            "Understand architectural trade-offs, performance considerations, and cost implications"
          ].map((item, i) => (
            <div key={i} style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* DETAILS */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          Throughout the course, I demonstrate how to design and implement serverless architectures
          using AWS services such as Lambda, API Gateway, DynamoDB, S3, and Step Functions.
        </p>

        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          The goal is to provide practical, hands-on experience that reflects real-world development scenarios—
          the same types of systems I build in consulting projects.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          If you're looking to strengthen your AWS development skills with a practical approach,
          this course will guide you step by step.
        </p>
      </div>


      {/* CTA SECTION (🔥 VERY IMPORTANT) */}
      <div style={{
        textAlign: "center",
        margin: "80px 0",
        padding: "50px 20px",
        background: "#fafafa"
      }}>
        <h2 style={{ marginBottom: "15px" }}>
          Start Learning Real-World AWS Development
        </h2>

        <p style={{
          color: "#555",
          marginBottom: "25px",
          fontSize: "16px"
        }}>
          Build production-ready systems and gain practical cloud experience.
        </p>

        <a
          href="https://www.skillshare.com/"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "inline-block",
            padding: "14px 32px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
          }}
        >
          View the Course →
        </a>
      </div>


      {/* FINAL NOTE */}
      <div style={sectionStyle}>
        <p style={{ lineHeight: "1.7", color: "#555" }}>
          The patterns and solutions presented in this course are based on real implementation experience.
          If you are looking to build similar systems or need support with AWS architecture,
          feel free to reach out.
        </p>
      </div>

    </div>
  );
};

export default AwsCourseSkillshare;